const DiscountType = {
  //SOS_DISCOUNT: 'SOS_DISCOUNT',
  TWENTY_FIVE_ON_THREE: 'TWENTY_FIVE_ON_THREE',
  TWENTY_SEVENTY: 'TWENTY_SEVENTY'
};

const DiscountSort = {
  //SOS_DISCOUNT: 0,
  TWENTY_FIVE_ON_THREE: 1,
  TWENTY_SEVENTY: 1
};
const DiscountName = {
  //SosShampooConditioner: 'discount_shampoo_conditioner',
  TwentyFiveOnThree: 'enable_twenty_five_on_three',
  TwentySeventy: 'enable_twenty_seventy'
};

const DiscountMap = {
  //[DiscountName.SosShampooConditioner]: DiscountType.SOS_DISCOUNT,
  [DiscountName.TwentyFiveOnThree]: DiscountType.TWENTY_FIVE_ON_THREE,
  [DiscountName.TwentySeventy]: DiscountType.TWENTY_SEVENTY
};

export default class RegimenUtils {
  /**
   *
   * @return {Array<DiscountType>}
   */
  static getDiscountTypeList() {
    const settings = localStorage.getItem('fob-settings');

    if (!settings) return [];

    const discountTypeList = [];

    const parsedSettings = JSON.parse(settings);

    for (const name in DiscountName) {
      if (!!parsedSettings[DiscountName[name]]) {
        discountTypeList.push(DiscountMap[DiscountName[name]]);
      }
    }

    return discountTypeList;
  }

  static UpdatePriceBanner({ selectedProducts, cartItems }) {
    const total = RegimenUtils.GetTotalPrice(selectedProducts, cartItems);

    RegimenUtils.SetPriceBanner(total);
  }
  static GetTotalPrice(selectedProducts, cartItems) {
    const discountTypeList = RegimenUtils.getDiscountTypeList();
    const products = [...new Set([].concat(selectedProducts, cartItems ?? []))];

    const prices = products
      .filter((x) => x.shopify_product_id)
      .map((x) => {
        const { priceElm, productElm, price } =
          RegimenUtils.getProductElements(x);

        return {
          price,
          priceString: priceElm
            ? priceElm.textContent
            : productElm?.dataset?.baseprice
        };
      });

    const totalPrice = prices.reduce((acc, curr) => {
      return acc + (isNaN(curr.price) ? 0 : curr.price);
    }, 0);

    if (discountTypeList.length > 0) {
      const discountsSorted = discountTypeList.sort(
        (a, b) => DiscountSort[a] - DiscountSort[b]
      );

      const totalWithDiscount = discountsSorted.reduce((acc, curr) => {
        return RegimenUtils.getTotalWithDiscount({
          totalPrice: acc,
          products,
          discountType: curr,
          prices
        });
      }, totalPrice);

      return {
        totalPrice,
        ...(totalWithDiscount !== 0 && { totalWithDiscount }),
        quantity: prices.length
      };
    }

    return {
      totalPrice,
      quantity: prices.length
    };
  }

  static getTotalWithDiscount({ discountType, products, totalPrice, prices }) {
    const appliedDiscountTotal = {
      /* [DiscountType.SOS_DISCOUNT]: () => {
        const discountValue =
          JSON.parse(localStorage.getItem('fob-settings'))?.[
            DiscountName.SosShampooConditioner
          ] ?? 0;
        const shampooAndConditionerDiscountValues = products
          .filter((x) => x.shopify_product_id)
          .filter(
            (x) =>
              (x.product_handle === 'sos-shampoo' ||
                x.product_handle === 'sos-conditioner') &&
              !!discountValue
          )
          .map((x) => {
            const { price } = RegimenUtils.getProductElements(x);

            const discountShampooOrConditionerFormatted = discountValue / 100;
            const discount = discountShampooOrConditionerFormatted * price;
            return discount;
          });

        const someDiscountSos = shampooAndConditionerDiscountValues.reduce(
          (acc, curr) => acc + curr,
          0
        );
        const productsWithDiscount = totalPrice - someDiscountSos;

        return productsWithDiscount;
      },*/
      [DiscountType.TWENTY_FIVE_ON_THREE]: () => {
        if (prices.length >= 3) return totalPrice - 0.25 * totalPrice;
        return 0;
      },
      [DiscountType.TWENTY_SEVENTY]: () => {
        if (totalPrice < 70) return totalPrice;

        return totalPrice - 2000;
      }
    };

    return appliedDiscountTotal?.[discountType]
      ? appliedDiscountTotal[discountType]()
      : 0;
  }

  static handleCheckIfOpenModal(event, self) {
    const isEditing = self.isEditing;
    const curr = event.currentTarget;
    const pid = curr.dataset.id;
    const productCard = document.getElementById(`product-${pid}`);
    if (isEditing) {
      const subscriptions = self.subscriptions;
      const productTitleCard = productCard.getAttribute('data-title');
      let hasSubscriptionItemSize = false;
      let hasSubscriptionItemColor = false;
      for (let i = 0; i < subscriptions.length; i++) {
        const parts = subscriptions[i]?.sku?.split('.');
        const size = parts?.length >= 2 ? parts[1] : '';
        const sizeIs8OzOr16Oz =
          (size.toLowerCase() === '8oz') | (size.toLowerCase() === '16oz')
            ? true
            : false;
        if (
          subscriptions[i].product_title === productTitleCard &&
          sizeIs8OzOr16Oz
        ) {
          hasSubscriptionItemSize = true;
          break;
        }
      }
      for (let i = 0; i < subscriptions.length; i++) {
        const parts = subscriptions[i]?.sku?.split('.');
        const color = parts?.[2];
        if (color) {
          const colorsToSearch =
            self?.fobSettings?.core_reform_colors_remove || '';
          const isCoreReformColor = colorsToSearch
            .toLowerCase()
            .includes(color?.toLowerCase());
          if (
            subscriptions[i].product_title === productTitleCard &&
            isCoreReformColor
          ) {
            hasSubscriptionItemColor = true;
            break;
          }
        }
      }
      if (hasSubscriptionItemSize) {
        subscriptions.forEach((sub) => {
          const parts = sub?.sku?.split('.');
          if (!parts) {
            return;
          }
          const productTitleSub = sub.product_title;
          const isSameProduct = productTitleSub === productTitleCard;
          if (parts?.length >= 2 && isSameProduct) {
            const size = parts[1];
            const sizeIs8OzOr16Oz =
              (size.toLowerCase() === '8oz') | (size.toLowerCase() === '16oz')
                ? true
                : false;
            if (sizeIs8OzOr16Oz) {
              const deleteCardProductModal = document.querySelector(
                'modal-component#modal-size'
              );
              deleteCardProductModal && (deleteCardProductModal.enabled = true);
              deleteCardProductModal
                ?.querySelector('#close-delete-card-button')
                ?.addEventListener('click', () => {
                  document.querySelector('modal-component#modal-size').enabled =
                    false;
                });
              const handleRemoveCardClick = function () {
                self.handleDeleteCard(event);
                document.querySelector('modal-component#modal-size').enabled =
                  false;
              };
              const removeCardButton = deleteCardProductModal?.querySelector(
                '#remove-card-button'
              );
              var oldButton = removeCardButton;
              var newButton = oldButton.cloneNode(true);
              newButton?.addEventListener('click', handleRemoveCardClick);
              oldButton.parentNode.replaceChild(newButton, oldButton);
            }
          }
        });
      } else if (hasSubscriptionItemColor) {
        subscriptions.forEach((sub) => {
          const parts = sub?.sku?.split('.');
          const productTitleSub = sub.product_title;
          const isSameProduct = productTitleSub === productTitleCard;
          if (parts.length >= 2 && isSameProduct) {
            const color = parts[2];
            const colorsToSearch =
              self?.fobSettings?.core_reform_colors_remove || '';
            const isCoreReformColor = colorsToSearch
              .toLowerCase()
              .includes(color?.toLowerCase());
            if (isCoreReformColor) {
              const deleteCardProductModal = document.querySelector(
                'modal-component#modal-colors'
              );
              deleteCardProductModal && (deleteCardProductModal.enabled = true);
              deleteCardProductModal
                ?.querySelector('#close-delete-card-button')
                ?.addEventListener('click', () => {
                  document.querySelector(
                    'modal-component#modal-colors'
                  ).enabled = false;
                });

              const handleRemoveCardClick = function () {
                self.handleDeleteCard(event);
                document.querySelector('modal-component#modal-colors').enabled =
                  false;
              };
              const removeCardButton = deleteCardProductModal?.querySelector(
                '#remove-card-button'
              );
              var oldButton = removeCardButton;
              var newButton = oldButton.cloneNode(true);
              newButton?.addEventListener('click', handleRemoveCardClick);
              oldButton.parentNode.replaceChild(newButton, oldButton);
            }
          }
        });
      } else {
        self.handleDeleteCard(event);
      }
    } else {
      self.handleDeleteCard(event);
    }
  }

  static SetPriceBanner({ totalPrice, quantity, totalWithDiscount }) {
    const regimenTotalPrice = document.getElementById('regimenTotalPrice');

    const formattedPrice = `${window.Shopify.formatMoney(
      totalPrice,
      window.theme.moneyFormat
    )}`;

    if (totalWithDiscount) {
      const formattedMewPrice = `${window.Shopify.formatMoney(
        totalWithDiscount,
        window.theme.moneyFormat
      )}`;

      regimenTotalPrice.innerHTML = `
                                        <div class="regimen-price-title">SUBTOTAL (${quantity}):&nbsp; </div>
                                        <div class="regimen-price-number">${formattedMewPrice} :&nbsp;</div>
                                        <div class="regimen-price-number" style="text-decoration: line-through">${formattedPrice}</div>
                                        `;
      return;
    }

    regimenTotalPrice.innerHTML = `
        <div class="regimen-price-title">SUBTOTAL (${quantity}):&nbsp; </div>
        <div class="regimen-price-number">${formattedPrice}</div>`;
  }

  static getProductElements(x) {
    const productElm = document.getElementById(
      `product-${x.shopify_product_id}`
    );
    if (!productElm) return { price: 0, priceString: '0' };
    const selectedSellingPlan = productElm.querySelector(
      `input[name="subscription_enable"]:checked`
    ).value;
    const priceElm =
      selectedSellingPlan == `subsave`
        ? productElm.querySelector(`.recharge .product-price`)
        : productElm.querySelector(`.onetime .product-price`);

    const price = priceElm
      ? Number(priceElm.getAttribute(`contentraw`))
      : Number(productElm.dataset.basepriceRaw);

    return { priceElm, productElm, price };
  }

  static changeCancelModalForCoreReformColors(cancelSubscription) {
    const settings = RegimenUtils.getSettings();
    let text = settings.cancel_sub_text_color ?? '';
    let popupLink = settings.cancel_sub_link_url_color ?? '';
    let label = settings.cancel_sub_link_label_color ?? '';
    let container = document.createElement('div');
    container.innerHTML = text;
    let lastParagraph = container.querySelector('p:last-of-type');
    let link = `<a href=${popupLink} class="edit-link" target="_blank"><u><b>${label}</b></u></a>`;

    lastParagraph && (lastParagraph.innerHTML += ' ' + link);

    text = container.innerHTML;
    const cancelSubscriptionModal = document.querySelector(
      '#cancel-subscription-modal'
    );
    cancelSubscriptionModal.querySelector('#cancel-flow-next').innerHTML = text;
    const modalButtons =
      cancelSubscriptionModal.querySelector('.actions-wrapper');
    modalButtons.innerHTML = `
            <button class="confirm-button cta-3" id="close-modal-button">Don't Cancel</button>
            <button class="confirm-button cta-3" id="cancel-subscription-button">Yes, cancel</button>`;
    const buttonCancelSubscription = modalButtons.querySelector(
      '#cancel-subscription-button'
    );
    buttonCancelSubscription.addEventListener('click', function () {
      cancelSubscription().then();
    });
  }

  static getSettings() {
    return JSON.parse(localStorage.getItem('fob-settings')) || [];
  }
}
